import styled from "styled-components";

export const Row = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 2px;
  border: none;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  background: none;
  cursor: pointer;
  text-align: left;
  font-family: ${(p) => p.theme.tokens.font.family};

  &:last-child {
    border-bottom: none;
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Sub = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const Chevron = styled.span`
  color: ${(p) => p.theme.tokens.colors.muted};
  display: flex;
  flex-shrink: 0;
`;
